import React, { useState, useEffect } from 'react';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import {
  faCalendar,
  faCalendarWeek,
  faEnvelope,
  faHeartCircleBolt,
  faHomeLgAlt,
  faMapMarkerAlt,
  faPhone,
  faVenusMars,
  faChevronUp,
  faChevronDown,
  faPen
} from '@fortawesome/free-solid-svg-icons';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import { MasterDataService } from '../../../services/masterDataService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { Card, Col, Container, Row, Button, Form, Modal } from 'react-bootstrap';
import { Cell, Pie, PieChart } from 'recharts';
import FileContentsPanel from '../../clients/candidate-information/client-right-content-panes/fileContentsPanel';
import CandidateLanguageProficiencyPanel from '../candidateRightContentPane/candidateLanguageProficiencyPanel';
import CandidateFamilyDetailsPanel from '../candidateRightContentPane/candidateFamilyDetailsPanel';
import CandidateInterestsPanel from '../candidateRightContentPane/candidateInterestsPanel';
import CandidateFileContentsPanel from '../candidateRightContentPane/candidateFileContentPanel';
import CloseIcon from '../../../assets/images/Ic_close.png';
import { BolnaService } from '../../../services/bolnaService';
import { decodeJWT } from '../../../services/candidateService';

export const ProfileRightContent = ({ candidateData }) => {
  const [candidateDocs, setCandidateDocs] = useState(_.get(candidateData, 'educationalDetails.educationalDocs') || []);
  const [additionalDocs, setAdditionalDocs] = useState(_.get(candidateData, 'valueAdds.additionalInfo') || []);
  const [errorMessage, setErrorMessage] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [aiCallScore, setAiCallScore] = useState(null);
  const [aiCallFeedback, setAiCallFeedback] = useState(null);
  const [isLoadingScore, setIsLoadingScore] = useState(false);

  const token = window.localStorage.getItem('authToken');
  const decoded = token ? decodeJWT(token) : null;
  const candidateId = _.get(decoded, 'username', '');

  useEffect(() => {
    const fetchAICallScore = async () => {
      if (!candidateId) {
        console.log('AI score: candidateId is empty');
        return;
      }

      console.log('AI score: calling API for candidateId:', candidateId);

      setIsLoadingScore(true);

      try {
        const response = await BolnaService.getCandidateProfile(candidateId);

        console.log('AI score API response:', response);
        console.log('AI score response data:', response?.data);
        console.log('AI score:', response?.data?.latestCallScore);
        console.log('AI feedback:', response?.data?.latestCallFeedback);

        setAiCallScore(response?.data?.latestCallScore ?? null);
        setAiCallFeedback(response?.data?.latestCallFeedback ?? null);
      } catch (error) {
        console.error('AI score API failed:', error);
        console.error('AI score API error response:', error?.response);

        setAiCallScore(null);
        setAiCallFeedback(null);
      } finally {
        setIsLoadingScore(false);
      }
    };

    fetchAICallScore();
  }, [candidateId]);

  useEffect(() => {
    MasterDataService.getAllCities()
      .then((res) => setCities(res.data))
      .catch((err) => console.error('Failed to load cities:', err));

    MasterDataService.getAllCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.error('Failed to load countries:', err));
  }, []);
  const [maritalStatus, setMaritalStatus] = useState(_.get(candidateData, 'personalDetails.maritalStatus', 'SINGLE'));

  const [profileData, setProfileData] = useState({
    linkedInUrl: _.get(candidateData, 'valueAdds.linkedInUrl', ''),
    primaryPhoneNumber: _.get(candidateData, 'personalDetails.primaryPhoneNumber', ''),
    primaryEmailId: _.get(candidateData, 'personalDetails.primaryEmailId', ''),
    dateOfBirth: _.get(candidateData, 'personalDetails.dateOfBirth', ''),
    gender: _.get(candidateData, 'personalDetails.gender', ''),
    // maritalStatus: _.get(candidateData, 'personalDetails.maritalStatus', ''),
    noticePeriod: _.get(candidateData, 'workExperience.currentRole.noticePeriod', ''),
    address1: _.get(candidateData, 'personalDetails.currentAddress.address1', ''),
    address2: _.get(candidateData, 'personalDetails.currentAddress.address2', ''),
    pinCode: _.get(candidateData, 'personalDetails.currentAddress.pinCode', ''),
    city: _.get(candidateData, 'personalDetails.currentAddress.city', ''),
    nativeCity: _.get(candidateData, 'valueAdds.nativeLocation', ''),
    state: _.get(candidateData, 'personalDetails.currentAddress.state', ''),
    country: _.get(candidateData, 'personalDetails.currentAddress.country', ''),
  });
  const genderOptions = ['MALE', 'FEMALE', "DONT_WANT_TO_SPECIFY"];
  const maritalStatusOptions = ['MARRIED', 'SINGLE', "DONT_WANT_TO_SPECIFY"];
  const fieldLabels = {
    linkedInUrl: 'LinkedIn URL',
    primaryPhoneNumber: 'Phone Number',
    primaryEmailId: 'Email ID',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    maritalStatus: 'Marital Status',
    noticePeriod: 'Notice Period (in days)',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    pinCode: 'PIN Code',
    city: 'City',
    state: 'State',
    country: 'Country',
    nativeCity: 'Native City',
  };
  const fieldOrder = [
    'linkedInUrl',
    'primaryPhoneNumber',
    'primaryEmailId',
    'dateOfBirth',
    'gender',
    'maritalStatus',
    'noticePeriod',
    'address1',
    'address2',
    'pinCode',
    'city',
    'state',
    'country',
    'nativeCity',
  ];

  const requiredFields = [
    'dateOfBirth',
    'gender',
    // 'noticePeriod',
    'country',
    'pinCode',
    'state',
    'city',
  ];

  const [formData, setFormData] = useState({
    ...profileData,
    maritalStatus: maritalStatus,
  });

  useEffect(() => {
    if (formData.pinCode && formData.pinCode.length === 6) {
      MasterDataService.getPinDetail(formData.pinCode)
        .then((res) => {
          const { district, state } = res.data;
          setFormData((prev) => ({
            ...prev,
            city: district || '',
            state: state || '',
          }));
        })
        .catch((err) => {
          console.error('Error fetching pin code details:', err);
          setFormData((prev) => ({ ...prev, city: '', state: '' }));
        });
    }
  }, [formData.pinCode]);

  const handleSave = async () => {
    const missingFields = requiredFields.filter((field) => {
      const value = formData[field];
      return value === undefined || value === null || value === '';
    });

    if (missingFields.length > 0) {
      setErrorMessage(`Please fill all required field(s): ${missingFields
        .map((f) => f.replace(/([A-Z])/g, ' $1'))
        .join(', ')}`);
      return;
    }
    try {
      setLoading(true);
      const payload = {
        linkedInUrl: formData.linkedInUrl,
        dateOfBirth: formData.dateOfBirth,
        gender: formData.gender,
        maritalStatus: formData.maritalStatus,
        noticePeriod: parseInt(formData.noticePeriod) || 0,
        nativeCity: formData.nativeCity,
        currentAddress: {
          address1: formData.address1,
          address2: formData.address2,
          city: formData.city,
          state: formData.state,
          pinCode: formData.pinCode || '',
          country: formData.country,
        },
      };

      // await CandidatePostLoginService.candidateValueAddRightPanel(payload);
      await CandidatePostLoginService.submitPanelByType('RIGHT_PANEL_SECTION_2', payload);

      setProfileData(formData);
      setMaritalStatus(formData.maritalStatus);
      setShowEditModal(false);
    } catch (error) {
      console.error('Failed to save candidate profile:', error);
    }
    finally {
      setLoading(false);
    }
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

  };
  const aiScoreData = aiCallScore !== null && aiCallScore !== undefined
    ? [
      { name: 'Score', value: aiCallScore },
      { name: 'Remaining', value: 100 - aiCallScore },
    ]
    : [
      { name: 'Score', value: 0 },
      { name: 'Remaining', value: 100 },
    ];

  const AI_SCORE_COLORS = ['#00D47A', '#E0E0E0'];


  const initial = {
    totalExperience: _.get(candidateData, 'workExperience.totalYrs') || '',
    CTC: _.get(candidateData, 'compensationDetails.total'),
    Fixed: _.get(candidateData, 'compensationDetails.fixed'),
    Variable: _.get(candidateData, 'compensationDetails.variable'),
    Bonus: _.get(candidateData, 'compensationDetails.bonus'),
    JoiningBonus: _.get(candidateData, 'compensationDetails.joiningBonus'),
    ESOP: _.get(candidateData, 'compensationDetails.esop'),
    OtherBenefits: _.get(candidateData, 'compensationDetails.otherBenefits'),
    Increment1: _.get(candidateData, 'compensationDetails.currentYr1stIncrementPercentage'),
    Increment2: _.get(candidateData, 'compensationDetails.currentYr2ndIncrementPercentage'),
    ExpectedCTC: _.get(candidateData, 'compensationDetails.expectedCtc'),
    FixedCTCExpectation: _.get(candidateData, 'compensationDetails.fixedCtcExpectation'),
    AdditionalNotes: _.get(candidateData, 'compensationDetails.additionalNotes'),
  };

  const [compFormValues, setCompFormValues] = useState(initial);
  const [compDisplayValues, setCompDisplayValues] = useState(initial);
  const [showCompModal, setShowCompModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [compFormErrors, setCompFormErrors] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const numericFields = [
    'CTC', 'Fixed', 'Variable', 'Bonus', 'JoiningBonus',
    'ESOP', 'OtherBenefits', 'Increment1', 'Increment2',
    'ExpectedCTC', 'FixedCTCExpectation', 'totalExperience'
  ];

  const handleCompChange = (e) => {
    const { name, value } = e.target;
    let error = '';
    if (numericFields.includes(name)) {
      const isValid = /^\d{0,3}(\.\d{0,2})?$/.test(value);
      const numericVal = parseFloat(value);
      if (!isValid && value !== '') {
        error = 'Please enter a valid number ';
      } else if (!isNaN(numericVal)) {
        if (name === 'totalExperience') {
          if (numericVal < 0) {
            error = 'Experience cannot be negative';
          } else if (numericVal > 100) {
            error = 'Please confirm if experience exceeds 100 years';
          }
        } else {
          if (numericVal >= 100000) {
            error = 'Please enter compensation in lakhs (e.g., 12 for ₹12,00,000)';
          } else if (numericVal > 999.99) {
            error = 'Compensation should not exceed 999.99 lakhs';
          }
        }
      }
    }
    if (name === 'AdditionalNotes') {
      const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
      if (wordCount > 250) {
        error = 'Additional notes cannot exceed 250 words';
      }
    }
    setCompFormValues((prev) => ({ ...prev, [name]: value }));
    setCompFormErrors((prev) => ({ ...prev, [name]: error }));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    let error = '';

    if (name === 'noticePeriod') {
      if (value !== '' && !/^\d*$/.test(value)) {
        error = 'Please Enter Only Numbers';
      }
    } else if (name === 'pinCode') {
      if (value !== '' && !/^\d+$/.test(value)) {
        error = 'PinCode must be a valid number';
      }
    }

    setFormErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    if (error) return;

    setFormData((prev) => ({
      ...prev,
      [name]: name === 'dateOfBirth' ? new Date(value).getTime().toString() : value,
    }));
  };

  const compFieldLabels = {
    totalExperience: 'Experience (Years)',
    CTC: 'CTC',
    Fixed: 'Fixed',
    Variable: 'Variable',
    Bonus: 'Bonus',
    JoiningBonus: 'Joining Bonus',
    ESOP: 'ESOP',
    OtherBenefits: 'Other Benefits',
    Increment1: 'Increment 1',
    Increment2: 'Increment 2',
    ExpectedCTC: 'Expected CTC',
    FixedCTCExpectation: 'Fixed CTC Expectation',
    AdditionalNotes: 'Additional Notes',
  };
  const compensationRequiredFields = [
    'totalExperience',
    'CTC',
    // 'Fixed',
  ];
  const handleCompSave = async () => {
    const missingFields = compensationRequiredFields.filter((field) => {
      const value = compFormValues[field];
      return value === undefined || value === null || value === '';
    });

    if (missingFields.length > 0) {
      setErrorMessage(`Please fill all required field(s):\n- ${missingFields
        .map((f) => f.replace(/([A-Z])/g, ' $1'))
        .join(', ')}`);
      return;
    }
    const payload = {
      total: Number(compFormValues.CTC),
      fixed: Number(compFormValues.Fixed),
      variable: Number(compFormValues.Variable),
      bonus: Number(compFormValues.Bonus),
      esop: Number(compFormValues.ESOP),
      otherBenefits: Number(compFormValues.OtherBenefits),
      joiningBonus: Number(compFormValues.JoiningBonus),
      currentYr1stIncrementPercentage: Number(compFormValues.Increment1),
      currentYr2ndIncrementPercentage: Number(compFormValues.Increment2),
      expectedCtc: Number(compFormValues.ExpectedCTC),
      fixedCtcExpectation: Number(compFormValues.FixedCTCExpectation),
      additionalNotes: compFormValues.AdditionalNotes || '',
      totalYrs: Number(compFormValues.totalExperience),
    };

    try {
      setLoading(true);
      // await CandidatePostLoginService.submitTotalExpCompensation(payload);
      await CandidatePostLoginService.submitPanelByType('TOTAL_EXP_COMPENSATION', payload);

      setCompDisplayValues(compFormValues);
      setShowCompModal(false);
    } catch (error) {
      console.error('Error submitting compensation data:', error);
      alert('Failed to save compensation details. Please try again.');
    }
    finally {
      setLoading(false);
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setFormErrors({});
    setErrorMessage('');
    setFormData(profileData);
  };

  const handleCloseCompModal = () => {
    setShowCompModal(false);
    setCompFormErrors({});
    setErrorMessage('');
    setCompFormValues(compDisplayValues);
  };

  // const formatDate = (timestamp) => {
  //   if (!timestamp) return null;
  //   const date = new Date(parseInt(timestamp));
  //   return date.toLocaleDateString('en-GB', {
  //     day: '2-digit',
  //     month: 'short',
  //     year: 'numeric',
  //   });
  // };
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = isNaN(timestamp)
      ? new Date(timestamp)
      : new Date(parseInt(timestamp));
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const toDateInputValue = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(parseInt(timestamp));
    return date.toISOString().split('T')[0];
  };
  return (
    // <Col className="col-3">
    <Col>

      <Card className="candidateInformation">
        {errorMessage && (
          <div className="custom-alert-overlay">
            <div className="custom-alert-box">
              <div className="custom-alert-content">
                <p>{errorMessage}</p>
                <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
        <Card.Body>
          <div className="innerCardContainer container p-2">
            <Row>
              <Col>
                <div
                  style={{
                    position: 'relative',
                    width: 70,
                    height: 80,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <PieChart width={70} height={80}>
                    <Pie
                      data={aiScoreData}
                      cx={35}
                      cy={40}
                      innerRadius={20}
                      outerRadius={30}
                      fill="#8884d8"
                      paddingAngle={1}
                      dataKey="value"
                      startAngle={90}
                      endAngle={-270}
                    >
                      {aiScoreData.map((entry, index) => (
                        <Cell
                          key={`ai-cell-${index}`}
                          fill={AI_SCORE_COLORS[index % AI_SCORE_COLORS.length]}
                        />
                      ))}
                    </Pie>
                  </PieChart>

                  <div
                    style={{
                      position: 'absolute',
                      top: '45px',
                      left: '40px',
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#172155',
                    }}
                  >
                    {isLoadingScore
                      ? '...'
                      : aiCallScore !== null && aiCallScore !== undefined
                        ? aiCallScore
                        : '--'}
                  </div>
                </div>
              </Col>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="experienceYears">{compDisplayValues.totalExperience}</span>
                  <span className="experienceYearsLabel"> Years</span>
                  <br />
                  <span className="experienceYearsSubLabel">Experience</span>
                </div>
                <button
                  onClick={() => {
                    setCompFormValues(compDisplayValues);
                    setShowCompModal(true);
                  }}
                  className="candidate-profile-edit-button"
                >
                  <FontAwesomeIcon icon={faPen} className="me-1" />
                </button>
              </Col>
            </Row>

            {!showDetails && (
              <Row>
                <Col>
                  <span className="experienceYears">{compDisplayValues.CTC}</span>
                  <span className="experienceYearsLabel"> lakhs</span>
                  <br />
                  <span className="experienceYearsSubLabel">CTC</span>
                </Col>
                <Col>
                  <span className="experienceYears">{compDisplayValues.Fixed}</span>
                  <span className="experienceYearsLabel"> lakhs</span>
                  <br />
                  <span className="experienceYearsSubLabel">Fixed Income</span>
                </Col>
              </Row>
            )}

            <Container className="mt-3">
              {showDetails && (
                <Row className="mt-2">
                  <Col>
                    <Row className="mb-1">
                      <Col xs={6}></Col>
                      <Col xs={6} className="right-col d-flex justify-content-end">
                        <span className="in-lakhs-text">In Lakhs</span>
                      </Col>
                    </Row>
                    {['CTC', 'Fixed', 'Variable', 'Bonus', 'JoiningBonus', 'ESOP', 'OtherBenefits', 'Increment1', 'Increment2', 'ExpectedCTC', 'FixedCTCExpectation'].map((key) => (
                      <Row className="mb-1" key={key}>
                        <Col xs={6} className="left-col">{key.replace(/([A-Z])/g, ' $1')}</Col>
                        <Col xs={6} className="right-col d-flex justify-content-end">
                          <div className="rupee-aligned">
                            <span className="rupee-prefix">Rs</span>
                            <span className="rupee-amount">{compDisplayValues[key]}</span>
                          </div>
                        </Col>
                      </Row>
                    ))}
                    <hr />
                    <Row className="mt-2">
                      <Col><h5 className="increment-heading">Additional Notes</h5></Col>
                    </Row>
                    <Row>
                      <Col className="left-col mb-1">{compDisplayValues.AdditionalNotes}</Col>
                    </Row>
                  </Col>
                </Row>
              )}
              <Row>
                <Col className="text-center">
                  <Button variant="link" className="p-0 ctc-toggle-button" onClick={() => setShowDetails(!showDetails)}>
                    {showDetails ? 'View Less' : 'View CTC Details'}{' '}
                    <FontAwesomeIcon icon={showDetails ? faChevronUp : faChevronDown} />
                  </Button>
                </Col>
              </Row>
            </Container>

            <Modal show={showCompModal} onHide={handleCloseCompModal} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
              <Modal.Header className="d-flex justify-content-between align-items-center">
                <Modal.Title>Edit Experience and CTC Details</Modal.Title>
                <img
                  src={CloseIcon}
                  alt="Close"
                  onClick={handleCloseCompModal}
                  style={{
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                  }}
                />
              </Modal.Header>
              <Modal.Body>
                <Form>
                  {Object.keys(compFormValues).map((key) => (
                    <Form.Group className="mb-3" key={key} controlId={`form-${key}`}>
                      <Form.Label>
                        {compFieldLabels[key] || key}
                        {compensationRequiredFields.includes(key) && <span style={{ color: 'red' }}> *</span>}
                      </Form.Label>
                      {key === 'AdditionalNotes' ? (
                        <>
                          <Form.Control
                            as="textarea"
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            rows={3}
                            name={key}
                            spellCheck='false'
                            value={compFormValues[key]}
                            onChange={handleCompChange}
                            isInvalid={!!compFormErrors?.[key]}

                          />
                          {compFormErrors?.[key] && (
                            <Form.Text className="text-danger">{compFormErrors[key]}</Form.Text>
                          )}
                        </>
                      ) : (
                        <>
                          <Form.Control
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            type="text"
                            name={key}
                            value={compFormValues[key]}
                            onChange={handleCompChange}
                            isInvalid={!!compFormErrors?.[key]}
                            spellCheck='false'
                          />
                          {compFormErrors?.[key] && (
                            <Form.Text className="text-danger">{compFormErrors[key]}</Form.Text>
                          )}
                        </>
                      )}
                    </Form.Group>
                  ))}
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button onClick={handleCloseCompModal} className="candidate-profile-edit-cancel">Cancel</button>
                <button
                  onClick={handleCompSave}
                  className="candidate-profile-edit-save"
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </Modal.Footer>
            </Modal>
          </div>

          <Container className="mt-3">
            <Row>
              <Col md={12} className="d-flex justify-content-end">
                <FontAwesomeIcon size='sm' icon={faPen} className="me-1"
                  onClick={() => {
                    setFormData({ ...profileData, maritalStatus });
                    setShowEditModal(true);
                  }}
                  style={{ color: '#F35825', cursor: 'pointer' }}
                />
              </Col>

              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faLinkedinIn} className="rounded-grey-icon" />
                </span>
                {profileData.linkedInUrl && (
                  <span style={{ marginLeft: '8px' }}>
                    <a
                      href={profileData.linkedInUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {`${_.get(candidateData, 'personalDetails.firstName', '')} ${_.get(candidateData, 'personalDetails.lastName', '')}`}
                    </a>
                  </span>
                )}


              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faPhone} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>{profileData.primaryPhoneNumber}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faEnvelope} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>{profileData.primaryEmailId}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faCalendar} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>{formatDate(profileData.dateOfBirth)}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faVenusMars} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>{profileData.gender}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faHeartCircleBolt} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>{maritalStatus}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faCalendarWeek} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>Notice Period: {profileData.noticePeriod} Days</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="rounded-grey-icon" />
                </span>
                <span style={{ marginLeft: '8px' }}>Native City: {profileData.nativeCity}</span>
              </Col>
              <Col md={12} className="candidateSubInfoLabels d-flex align-items-center">
                <span className="rounded-grey-background d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon icon={faHomeLgAlt} className="rounded-grey-icon" />
                </span>
                <span className="address-text" style={{ marginLeft: '8px' }}>
                  <strong>Current Address:</strong>{' '}<br />
                  {profileData.address1}, {profileData.address2}, {profileData.city},
                  {` ${profileData.state}, ${profileData.country} - ${profileData.pinCode}`}
                </span>
              </Col>

            </Row>

            <Modal show={showEditModal} onHide={handleCloseEditModal} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
              <Modal.Header className="d-flex justify-content-between align-items-center">
                <Modal.Title>Edit Candidate Profile</Modal.Title>
                <img
                  src={CloseIcon}
                  alt="Close"
                  onClick={handleCloseEditModal}
                  style={{
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                  }}
                />
              </Modal.Header>
              <Modal.Body>
                <Form>
                  {fieldOrder.map((key) => (
                    <Form.Group className="mb-3" controlId={`form-${key}`} key={key} spellCheck='false'>
                      <Form.Label>
                        {fieldLabels[key] || key}
                        {requiredFields.includes(key) && <span style={{ color: 'red' }}> *</span>}
                      </Form.Label>

                      {key === 'country' ? (
                        <Form.Select
                          style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country} value={country}>{country}</option>
                          ))}
                        </Form.Select>
                      ) : key === 'gender' ? (
                        <Form.Select
                          style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option value="">Select Gender</option>
                          {genderOptions.map((option) => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </Form.Select>
                      ) : key === 'maritalStatus' ? (
                        <Form.Select
                          style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                          name="maritalStatus"
                          value={formData.maritalStatus}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Marital Status</option>
                          {maritalStatusOptions.map((option) => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </Form.Select>
                      ) : key === 'nativeCity' ? (
                        <Form.Select
                          style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                          name="nativeCity"
                          value={formData.nativeCity}
                          onChange={handleChange}
                        >
                          <option value="">Select Native Location</option>
                          {cities.map((city) => (
                            <option key={city} value={city}>{city}</option>
                          ))}
                        </Form.Select>
                      ) :
                        key === 'primaryPhoneNumber' || key === 'primaryEmailId' ? (
                          <div
                            className="form-control d-flex align-items-center"
                            style={{ cursor: 'not-allowed' }}
                          >
                            <FontAwesomeIcon className="me-2 text-muted" />
                            <span>{formData[key]}</span>
                          </div>
                        ) : key === 'city' || key === 'state' ? (
                          <div
                            className="form-control d-flex align-items-center"
                            style={{ cursor: 'not-allowed' }}
                          >
                            <FontAwesomeIcon className="me-2 text-muted" />
                            <span>{formData[key]}</span>
                          </div>
                        ) : key === 'pinCode' ? (
                          <Form.Control
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            type="text"
                            name="pinCode"
                            value={formData.pinCode}
                            onChange={handleChange}
                            isInvalid={!!formErrors.pinCode}
                          />
                        ) : (
                          <Form.Control
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            type={key === 'dateOfBirth' ? 'date' : 'text'}
                            name={key}
                            value={key === 'dateOfBirth' ? toDateInputValue(formData[key]) : formData[key]}
                            onChange={handleChange}
                            readOnly={key === 'city' || key === 'state'}
                            isInvalid={!!formErrors[key]}
                          />
                        )}
                      {formErrors.pinCode && key === 'pinCode' && (
                        <Form.Text className="text-danger">{formErrors.pinCode}</Form.Text>
                      )}
                    </Form.Group>
                  ))}
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <button onClick={handleCloseEditModal} className="candidate-profile-edit-cancel">
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="candidate-profile-edit-save"
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </Modal.Footer>
            </Modal>
          </Container>
        </Card.Body>
      </Card>
      <CandidateLanguageProficiencyPanel
        languageProficiency={_.get(candidateData, 'valueAdds.languageProficiencies')}
      />
      <CandidateInterestsPanel interests={_.get(candidateData, 'valueAdds.interests')}></CandidateInterestsPanel>
      <CandidateFamilyDetailsPanel
        familyDetails={{
          ..._.get(candidateData, 'valueAdds'),
        }}
        maritalStatus={maritalStatus}
        setMaritalStatus={setMaritalStatus}
      />


      <CandidateFileContentsPanel
        title="Documents"
        fileType="EDUCATIONAL"
        fileList={candidateDocs}
        onUploadSuccess={(newFile) => {
          setCandidateDocs(prev => [...prev, newFile]);
        }}
        tooltipText="Upload your educational certificates, experience letters etc (PDF/DOC)."

      ></CandidateFileContentsPanel>
      <FileContentsPanel
        title="DISC Assessment Report"
        fileList={_.get(candidateData, 'educationalDetails.assessmentFiles')}
      ></FileContentsPanel>

      <CandidateFileContentsPanel
        title="Additional Information"
        fileType="ADD_INFO"
        fileList={additionalDocs}
        onUploadSuccess={(newFile) => {
          setAdditionalDocs(prev => [...prev, newFile]);
        }}
        tooltipText=" Upload any other supporting documents (e.g., recommendation letters) — PDF/DOC."

      ></CandidateFileContentsPanel>
    </Col>
  );
};